import {
    GET_ALL_INVOICE,
    GET_ALL_SEARCH,
    GET_SINGLE_PRODUCT,
    GET_ALL_SIMILAR,
    GET_ALL_USER_INVOICES,
    GET_ALL_USER_RETURNS,
    GET_ALL_DASHBOARD,
    RESPONSE_STATUS,
    GET_ALL_BID_HISTORY,
    GET_ALL_TTWBID_HISTORY,
    GET_ALL_ACTIVE_SORTS,
    GET_ALL_RETURN_INVOICE,
    CLEAR_RESPONSE,
    GET_SAVED_SEARCHES,
    TTWBID_HISTORY_BY_USER,
    GET_ALL_PRODUCTS,
    GET_FOLLOWERS,
    GET_TOTAL_AUCTIONS_WON,
    GET_TOTAL_AUCTIONS_PLACED,
    TOTAL_PRIVATE_SALE_PRODUCTS,
    GET_ALL_UPCOMING_PRODUCT,
    GET_ALL_OFFERS,
    SAVED_SEARCH_MODAL,
    PHONE_MODEL_POPUP,
} from './productTypes'

export default (state, action) => {
    switch (action.type) {
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case GET_ALL_SEARCH:
            return {
                ...state,
                search_allproducts: action.payload,
            }
        case GET_SINGLE_PRODUCT:
            return {
                ...state,
                single_product: action.payload,
            }
        case GET_ALL_UPCOMING_PRODUCT:
            return {
                ...state,
                search_all_upcomingproducts: action.payload,
            }
        case GET_ALL_BID_HISTORY:
            return {
                ...state,
                search_allbidhistory: action.payload,
            }
        case GET_ALL_TTWBID_HISTORY:
            return {
                ...state,
                search_allttwbidhistory: action.payload,
            }
        case GET_ALL_USER_INVOICES:
            return {
                ...state,
                search_alluserinvoices: action.payload,
            }
        case GET_ALL_USER_RETURNS:
            return {
                ...state,
                search_alluserreturns: action.payload,
            }

        case GET_ALL_SIMILAR:
            return {
                ...state,
                search_allsimilar: action.payload,
            }
        case GET_ALL_INVOICE:
            return {
                ...state,
                search_allinvoiceproducts: action.payload,
            }
        case GET_ALL_RETURN_INVOICE:
            return {
                ...state,
                search_allreturninvoiceproducts: action.payload,
            }

        case GET_ALL_ACTIVE_SORTS:
            return {
                ...state,
                active_sorts: action.payload,
            }
        case GET_ALL_DASHBOARD:
            return {
                ...state,
                search_alldashboardproducts: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        case GET_SAVED_SEARCHES:
            return {
                ...state,
                saved_searches: action.payload,
            }
        case GET_FOLLOWERS:
            return {
                ...state,
                followers: action.payload,
            }
        case TTWBID_HISTORY_BY_USER:
            return {
                ...state,
                ttwBidsByUser: action.payload,
            }
        case GET_ALL_PRODUCTS:
            return {
                ...state,
                listingFromAdmin: action.payload,
            }
        case GET_TOTAL_AUCTIONS_WON:
            return {
                ...state,
                totalAuctionsWon: action.payload,
            }
        case GET_TOTAL_AUCTIONS_PLACED:
            return {
                ...state,
                totalAuctionsPlaced: action.payload,
            }
        case TOTAL_PRIVATE_SALE_PRODUCTS:
            return {
                ...state,
                totalPrivateSaleProducts: action.payload,
            }
        case GET_ALL_OFFERS:
            return {
                ...state,
                all_offers: action.payload,
            }
        case SAVED_SEARCH_MODAL:
            return {
                ...state,
                savedSearchModel: action.payload.value,
            }
        case PHONE_MODEL_POPUP:
            return {
                ...state,
                phonemodelPopup: !state.phonemodelPopup,
            }
        default:
            return state
    }
}
